module.exports = __webpack_public_path__ + "img/ctrl-pauli-stub-up-+.c25b695e.svg";